export default __webpack_public_path__ + "static/media/StudentImage.29294cb6.svg";